<template>
  <div v-show="this.events.length > 0" class="bg-white mb-5">
    <h2
      class="text-center uppercase font-medium leading-tight mb-5"
      >Our Events</h2>

    <div v-for="myEvent in events">
      <div class="flex items-center bg-gray-100 rounded-full mb-4 pr-8 w-64 mx-auto py-3">
        <div class="bg-pink-500 text-white rounded-full min-w-[90px] min-h-[90px] max-h-[90px] max-w-[90px] flex flex-col items-center justify-center">
          <p class="font-custom font-bold tracking-widest my-0 leading-none text-2xl uppercase">{{myEvent.beginMonth}}</p>
          <p class="font-custom font-bold leading-none my-0 leading-none text-4xl mt-[-3px]">{{myEvent.beginDay}}</p>
          <p class="font-custom-light font-light my-0 leading-none text-sm">{{myEvent.timeRange}}</p>
        </div>
        <div class="ml-4 flex flex-col">
          <p class="text-custom-pill font-medium text-2xl leading-5 mb-2">{{myEvent.title}}</p>
          <div class="flex items-center">
            <i class="fas fa-map-marker-alt text-pink-500"></i>
            <a :href="myEvent.googleMapUrl" target="_blank" class="text-link ml-1 leading-none text-sm underline">{{ myEvent.city }}, {{ myEvent.state }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CampaignEventDisplay',
    props: {
      campaignId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        events: [],
      }
    },
    created() {
      axios.get(`/campaign/${this.campaignId}/events`)
          .then(response => {
            this.events = response.data
          })
          .catch(error => {
            console.error('Error fetching campaign events:', error);
          });
    },
  }
</script>

<style>
.font-custom {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 700;
}
.font-custom-light {
  font-family: "Barlow Condensed", sans-serif;
  font-weight: 300;
}
.text-custom-pill {
  font-family: "Barlow Condensed", sans-serif;
  font-weight: 500;
}
.text-link {
  font-family: "Barlow Condensed", sans-serif;
  font-weight: 400;
  text-decoration-line: underline;
  color: #DA1884;
}
</style>
